
<div class="row ss-top-menu">
  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Lead Priorities</span>
  </div>
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5">
    <div class="ss-searchbox">
      <i class="fa fa-search"></i>
      <input class="form-control" type="text" placeholder="Type name, status, location to search..." #search (keyup)="0">
    </div>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>


<div class="rk-marginTop row">

  <!-- <div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
      <div class="alert alert-danger mt-3 text-center">
        <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
        {{errorMessage}}
      </div>
    </div>
  </div> -->
  <!-- <div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
      <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
        {{successMessage}}
      </div>
    </div>
  </div> -->
</div>
<div class="container-fluid container-set mb-3">
  <div class="row">
    <div class="col-md-12 mb-2">
      <button class="addCursor rk-interalBtnColor mt-3 pull-right mb-1" data-toggle="modal" data-target="#createpriorityModal">Create New Priority</button>
    </div>
    <!-- <div class="col-md-12 mb-2">
      <a (click)="openPriorityForm()" class="addCursor ss-text-dark">Create new priority</a>
    </div> -->
    <!-- <div class="col-md-12 d-none mb-2" id="priorityFormRow">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="createPriorityForm">
            <div class="row" *ngIf="selectOptions">
              <div class="col-md-4 rk-form-fontsize">
                <label>Enter Lead Source </label>
                <select formControlName="lead_source_id" class="form-control capitalize">
                  <option value="" disabled="">Select Lead Source</option>
                  <option value="">All</option>
                  <option value="{{source.id}}" *ngFor="let source of selectOptions.lead_sources">{{source.name | replaceChar}}</option>
                </select>    
              </div>
              <div class="col-md-4 rk-form-fontsize">
                <label>Enter Lead Type</label>
                <select formControlName="lead_type_id" class="form-control capitalize">
                  <option value="" disabled="">Select Lead Type</option>
                  <option value="">All</option>
                  <option value="{{type.id}}" *ngFor="let type of selectOptions.lead_types">{{type.name | replaceChar}}</option>
                </select>
              </div>
              <div class="col-md-4 rk-form-fontsize">
                <label>Enter Lead Campaign</label>
                <select formControlName="lead_campaign_id" class="form-control capitalize">
                  <option value="" disabled="">Select Campaign</option>
                  <option value="">All</option>
                  <option value="{{camp.id}}" *ngFor="let camp of selectOptions.lead_campaigns">{{camp.name | replaceChar}}</option>
                </select>
              </div>
              <div class="col-md-12 text-right">
                <button (click)="closeForm()" class=" mt-2 rk-btnCancel">Cancel</button>
                <button class=" mt-2 rk-interalBtnColor" (click)="createNewPriority(createPriorityForm.value)">Create</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div> -->
    <div class="col-md-12">
      <div class="rk-tableDiv">
        <p class="text-center" *ngIf="prioritiesList &&  prioritiesList.length==0 ">No Priorities</p>
        <table class="table" *ngIf="prioritiesList &&  prioritiesList.length>0">
          <thead>
            <tr>
              <th class="text-center rk-firstTh">Priority No.</th>
              <th>Lead Source </th>
              <th>Lead Type</th>
              <th>Lead Campaign</th>
              <th class="rk-lastTh">Change Priority</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of prioritiesList | category: search.value; let i = index; " [attr.data-index]="i" id="campaignRow{{i}}">
              <td class="text-center">{{data.priority_number}}</td>
              <td class="capitalize">
                	<span class="editRowSpan{{i}} capitalize">{{data.lead_source | replaceChar}}</span>
                	<select class="d-none editRowInput{{i}} form-control capitalize"[(ngModel)]="editPriorityLeadSource">
                  	<option value="">All</option>
                  	<option value="{{source.id}}" *ngFor="let source of selectOptions.lead_sources">{{source.name | replaceChar}}</option>
               	 </select>
              </td>
              <td>
                	<span class="editRowSpan{{i}} capitalize">{{data.lead_type | replaceChar}}</span>
                	<select class="d-none editRowInput{{i}} form-control capitalize"[(ngModel)]="editPriorityLeadType">
                  	<option value="">All</option>
                  	<option value="{{type.id}}" *ngFor="let type of selectOptions.lead_types">{{type.name | replaceChar}}</option>
               	 </select>
              </td>
              <td>
                	<span class="editRowSpan{{i}} capitalize">{{data.lead_campaign | replaceChar}}</span>
                	<select class="d-none editRowInput{{i}} form-control lastTdEditFormInput capitalize"[(ngModel)]="editPriorityLeadCampaign">
                  	<option value="">All</option>
                  	<option value="{{camp.id}}" *ngFor="let camp of selectOptions.lead_campaigns">{{camp.name | replaceChar}}</option>
               	</select>
               	<button class="d-none editRowInput{{i}} rk-interalBtnColor mx-2" (click)="updatePriorityData(i,data.id)">Update</button>
                	<button class="d-none editRowInput{{i}} rk-btnCancel" (click)="cancelEditPriorityRow(i)">Cancel</button>
              </td>
              <td>
                <div class="row">
                  <div class="col-md-6">
                    <div class="dropdown" style="display: inline-block;">
                      <div class="form-control" id="dropdownMenuButton{{i}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form-control lastTdEditFormInput" (click)="changedPriorityNumber=undefined">Select Priority</div>
                      
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width: 100%;">
                        <a class="dropdown-item" (click)="setDataInDropDownDiv(data,'Top','ion-arrow-up-a',i,'up','max')"><i class="ion-arrow-up-a mr-1"></i>Top</a>
                        <a class="dropdown-item" (click)="setDataInDropDownDiv(data,'Bottom','ion-arrow-down-a',i,'down','max')"><i class="ion-arrow-down-a mr-1"></i>Bottom</a>
                        <a class="dropdown-item" (click)="setDataInDropDownDiv(data,'Move Up','ion-arrow-up-c',i,'up','1')"><i class="ion-arrow-up-c mr-1"></i>Move Up</a>
                        <a class="dropdown-item" (click)="setDataInDropDownDiv(data,'Move Down','ion-arrow-down-c',i,'down','1')"><i class="ion-arrow-down-c mr-1"></i>Move Down</a>
                        <a class="dropdown-item"><input type="number" min="1" max="{{maxPriorityNumber}}" name="" placeholder="Enter position" class="form-control" style="display: inline-block; width: 72%" [(ngModel)]="changedPriorityNumber"><button class="ml-1" (click)="setDataInDropDownDiv(data,changedPriorityNumber,'',i,'','')">Save</button></a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="dropdown">
                      <i class="ion-android-more-vertical pull-right mr-2 ss-3-dot-drop editRowSpan{{i}}" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"></i>
                      <div class="dropdown-menu editRowSpan{{i}}" style="font-size: 14px;">
                        <a class="dropdown-item" (click)="editPriority(i,data)">
                         <i class="ion-edit"></i>
                         Edit
                        </a>
                        <a class="dropdown-item" (click)="deletePriority(i,data)">
                         <i class="ion-ios-trash"></i>
                         Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="createpriorityModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Create New Priority</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="createPriorityForm">
          <div class="row">
            <div class="col-md-11 mt-3 ml-3 rk-form-fontsize">
              <label class="mr-3">Enter Lead Source</label>
              <select formControlName="lead_source_id" class="form-control capitalize">
                <option value="" disabled="">Select Lead Source</option>
                <option value="">All</option>
                <option value="{{source.id}}" *ngFor="let source of selectOptions.lead_sources">{{source.name | replaceChar}}</option>
              </select>
            </div>
            <div class="col-md-11 mt-3 ml-3 rk-form-fontsize">
              <label class="mr-3">Enter Lead Type</label>
              <select formControlName="lead_type_id" class="form-control capitalize">
                  <option value="" disabled="">Select Lead Type</option>
                  <option value="">All</option>
                  <option value="{{type.id}}" *ngFor="let type of selectOptions.lead_types">{{type.name | replaceChar}}</option>
              </select>
            </div>
            <div class="col-md-11 mt-3 ml-3 rk-form-fontsize">
              <label class="mr-3">Enter Lead Campaign</label>
                <select formControlName="lead_campaign_id" class="form-control capitalize">
                  <option value="" disabled="">Select Campaign</option>
                  <option value="">All</option>
                  <option value="{{camp.id}}" *ngFor="let camp of selectOptions.lead_campaigns">{{camp.name | replaceChar}}</option>
                </select>
            </div>
            <div class="col-md-12 mt-4 text-right modal-footer">
              <button class=" mt-2 rk-interalBtnColor addCursor" (click)="createNewPriority(createPriorityForm.value)">Create</button>
              <button data-dismiss="modal" class=" mt-2 mr-5 rk-btnCancel addCursor" (click)="closeForm()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>





// WEBPACK FOOTER //
// ./src/app/platform/organisation/leadcampaign/leads-priority/leads-priority.component.html